import { render } from "./SuspendBulkCampaignAction.vue?vue&type=template&id=310b0155"
import script from "./SuspendBulkCampaignAction.vue?vue&type=script&lang=ts"
export * from "./SuspendBulkCampaignAction.vue?vue&type=script&lang=ts"
script.render = render

export default script